import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

const loader = new GLTFLoader();
const cache = new Map();

export async function loadModel(path) {

  if (cache.has(path)) {
    return cache.get(path);
  }

  const gltf = await loader.loadAsync(path);

  cache.set(path, gltf);

  return gltf;
}